import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import Footer from '../Footer';

import servicesSectionBg from '../../assests/servicessection1bg.png';
import homeicon from '../../assests/karaicon.svg';

// Import all service card images
import serviceCard1Image from '../../assests/servicecard1.png';
import serviceCard2Image from '../../assests/servicecard2.png';
import serviceCard3Image from '../../assests/servicecard3.png';
import serviceCard4Image from '../../assests/servicecard4.png';
import serviceCard5Image from '../../assests/servicecard5.png';
import serviceCard6Image from '../../assests/servicecard6.png';
import serviceCard7Image from '../../assests/servicecard7.png';
import serviceCard8Image from '../../assests/servicecard8.png';
import serviceCard9Image from '../../assests/servicecard9.png';

const Services = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const location = useLocation();
  const [isConceptOpen, setIsConceptOpen] = useState(false);

const toggleConceptMenu = () => {
  setIsConceptOpen(!isConceptOpen);
};

  // Track when page is fully loaded
  useEffect(() => {
    const handleLoad = () => {
      setIsPageLoaded(true);
    };

    if (document.readyState === 'complete') {
      setIsPageLoaded(true);
    } else {
      window.addEventListener('load', handleLoad);
      // Fallback timeout
      const timeout = setTimeout(() => setIsPageLoaded(true), 2000);
      
      return () => {
        window.removeEventListener('load', handleLoad);
        clearTimeout(timeout);
      };
    }
  }, []);

  // Scroll to service when page is loaded and hash exists
  useEffect(() => {
    if (!isPageLoaded) return;
    
    const scrollToService = () => {
      if (!location.hash) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const targetId = location.hash.substring(1);
      console.log('Looking for service:', targetId);

      // Wait a bit for layout to stabilize
      setTimeout(() => {
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          console.log('Element found:', targetElement);
          
          // Method 1: Using scrollIntoView (most reliable)
          targetElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
          
          // After scrolling, adjust for navbar
          setTimeout(() => {
            const navbarHeight = 100;
            window.scrollBy({ 
              top: -navbarHeight, 
              behavior: 'smooth' 
            });
          }, 500);
          
          // Add highlight effect
          setTimeout(() => {
            targetElement.classList.add('service-highlight');
            setTimeout(() => {
              targetElement.classList.remove('service-highlight');
            }, 3000);
          }, 1000);
          
        } else {
          console.error('Element not found:', targetId);
          
          // Try alternative method using querySelector
          const alternativeElement = document.querySelector(`[data-service="${targetId}"]`);
          if (alternativeElement) {
            console.log('Found element using data-service attribute');
            alternativeElement.scrollIntoView({ 
              behavior: 'smooth', 
              block: 'start' 
            });
            
            setTimeout(() => {
              window.scrollBy({ 
                top: -100, 
                behavior: 'smooth' 
              });
            }, 500);
          }
        }
      }, 500); // Give time for all content to render
    };

    scrollToService();
  }, [location.hash, isPageLoaded]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className="services-navbar">
        <div className="services-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="services-logo-icon" />
          </Link>
        </div>
        <div className="services-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="services-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="services-nav-overlay">
          <div className="services-nav-close" onClick={toggleMenu}>
            <IoClose className="services-close-icon" />
          </div>
          <nav className="services-navigation">
            <ul className="services-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li className="active"><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li> */}
               {/* <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Services Hero */}
      <section className="services-section-1">
        <div className="services-section-1-background">
          <img src={servicesSectionBg} alt="Services Background" className="services-section-1-bg-image" />
        </div>
        <div className="services-section-1-overlay"></div>
        <div className="services-section-1-content">
          <p className="services-section-1-label">Services</p>
          <h1 className="services-section-1-title">
            Tailored Design Solutions for <br/> Unique Interior Challenges
          </h1>
          <p className="services-section-1-description">
            From concept to craftsmanship, Kara offers end-to-end product design services that transform your spaces into stories.
          </p>
        </div>
      </section>

      {/* SECTION 2: First Two Service Cards */}
      <section className="services-section-2">
        <div className="services-section-2-container">
          
          {/* Card 1 - Bespoke Product Design */}
          <div 
            className="services-section-2-card service-card-wrapper" 
            id="bespoke-product-design"
            data-service="bespoke-product-design"
          >
            <div className="services-section-2-card-image-wrapper">
              <img 
                src={serviceCard1Image} 
                alt="Bespoke Product Design" 
                className="services-section-2-card-image" 
              />
            </div>
            
            <h3 className="services-section-2-card-heading">
              Bespoke Product Design & Development
            </h3>
            
            <h4 className="services-section-2-card-subheading">
              One-of-One Luxury – Designed for You, Never Repeated.
            </h4>
            
            <ul className="services-section-2-card-list">
              <li>Ultra-exclusive, custom-designed home décor (furniture, lighting, sculptures, accent pieces).</li>
              {/* <li>Heritage & Cultural Fusion: Blending historical influences with modern luxury.</li>
              <li>Personalized material selection from ethically sourced rare woods, metals, and textiles.</li> */}
            </ul>
          </div>

          {/* Card 2 - Limited Edition Collections */}
          <div 
            className="services-section-2-card service-card-wrapper" 
            id="limited-edition-collections"
            data-service="limited-edition-collections"
          >
            <div className="services-section-2-card-image-wrapper">
              <img 
                src={serviceCard2Image} 
                alt="Limited Edition Collections" 
                className="services-section-2-card-image" 
              />
            </div>
            
            <h3 className="services-section-2-card-heading">
              Limited-Edition Luxury Collections
            </h3>
            
            <h4 className="services-section-2-card-subheading">
              Art Meets Function – Collectible Décor for the Discerning Few.
            </h4>
            
            <ul className="services-section-2-card-list">
              <li>Seasonal small-batch luxury décor collections, each piece handcrafted.</li>
              {/* <li>Artist & Designer Collaborations: Unique, collectible home décor co-created with world-class designers.</li>
              <li>Signature Interior Accents curated for high-end residences and boutique spaces.</li> */}
            </ul>
          </div>

        </div>
      </section>

      {/* SECTION 3: Next Two Service Cards */}
      <section className="services-section-3">
        <div className="services-section-3-container">
          
          {/* Card 3 - Material Sourcing */}
          <div 
            className="services-section-3-card service-card-wrapper" 
            id="material-sourcing"
            data-service="material-sourcing"
          >
            <div className="services-section-3-card-image-wrapper">
              <img 
                src={serviceCard3Image} 
                alt="Material Sourcing" 
                className="services-section-3-card-image" 
              />
            </div>
            
            <h3 className="services-section-3-card-heading">
              Material Sourcing & Traceability Consulting
            </h3>
            
            <h4 className="services-section-3-card-subheading">
              Luxury with a Story – Every Material, Ethically Sourced & Verified.
            </h4>
            
            <ul className="services-section-3-card-list">
              <li>Rare, traceable materials from reclaimed heritage sites, forests, and architectural ruins.</li>
              {/* <li>Eco-conscious material research, ensuring sustainability without compromising aesthetics.</li> */}
            </ul>
          </div>

          {/* Card 4 - High-End Manufacturing */}
          <div 
            className="services-section-3-card service-card-wrapper" 
            id="high-end-manufacturing"
            data-service="high-end-manufacturing"
          >
            <div className="services-section-3-card-image-wrapper">
              <img 
                src={serviceCard4Image} 
                alt="High-End Manufacturing" 
                className="services-section-3-card-image" 
              />
            </div>
            
            <h3 className="services-section-3-card-heading">
              High-End Manufacturing & Artisan Partnerships
            </h3>
            
            <h4 className="services-section-3-card-subheading">
              Where Craftsmanship Meets Innovation.
            </h4>
            
            <ul className="services-section-3-card-list">
              <li>Exclusive collaborations with master artisans worldwide.</li>
              {/* <li>Handcrafted techniques blended with cutting-edge design technologies.</li>
              <li>Custom furniture prototyping & manufacturing with precise attention to detail.</li> */}
            </ul>
          </div>

        </div>
      </section>

      {/* SECTION 4: Next Two Service Cards */}
      <section className="services-section-4">
        <div className="services-section-4-container">
          
          {/* Card 5 - Sustainable Design */}
          <div 
            className="services-section-4-card service-card-wrapper" 
            id="sustainable-design"
            data-service="sustainable-design"
          >
            <div className="services-section-4-card-image-wrapper">
              <img 
                src={serviceCard5Image} 
                alt="Sustainable Design" 
                className="services-section-4-card-image" 
              />
            </div>
            
            <h3 className="services-section-4-card-heading">
              Sustainable & Circular Design Solutions
            </h3>
            
            <h4 className="services-section-4-card-subheading">
              Carbon-Negative Luxury That Gives Back.
            </h4>
            
            <ul className="services-section-4-card-list">
              <li>Carbon-negative production, ensuring a minimal environmental footprint.</li>
              {/* <li>Upcycling & Reclaimed Materials: Reimagining historical materials into contemporary luxury.</li>
              <li>Take-Back & Refurbishment Programs: Clients can refresh or resell Studio Kara pieces.</li> */}
            </ul>
          </div>

          {/* Card 6 - Luxury Packaging */}
          <div 
            className="services-section-4-card service-card-wrapper" 
            id="luxury-packaging"
            data-service="luxury-packaging"
          >
            <div className="services-section-4-card-image-wrapper">
              <img 
                src={serviceCard6Image} 
                alt="Luxury Packaging" 
                className="services-section-4-card-image" 
              />
            </div>
            
            <h3 className="services-section-4-card-heading">
              Luxury Packaging & Unboxing Experience
            </h3>
            
            <h4 className="services-section-4-card-subheading">
              A Masterpiece Deserves a Grand Reveal.
            </h4>
            
            <ul className="services-section-4-card-list">
              <li>Bespoke, eco-friendly packaging designed to elevate the customer experience.</li>
              {/* <li>Personalized unboxing moments with storytelling elements.</li>
              <li>Gifting & Collector's Edition Packaging for VIP clients.</li> */}
            </ul>
          </div>

        </div>
      </section>

      {/* SECTION 5: Next Two Service Cards */}
      <section className="services-section-5">
        <div className="services-section-5-container">
          
          {/* Card 7 - Concierge Services */}
          <div 
            className="services-section-5-card service-card-wrapper" 
            id="concierge-services"
            data-service="concierge-services"
          >
            <div className="services-section-5-card-image-wrapper">
              <img 
                src={serviceCard7Image} 
                alt="Concierge Services" 
                className="services-section-5-card-image" 
              />
            </div>
            
            <h3 className="services-section-5-card-heading">
              High-Touch Concierge & Private Client Services
            </h3>
            
            <h4 className="services-section-5-card-subheading">
              By Invitation Only – A Tailored Luxury Experience.
            </h4>
            
            <ul className="services-section-5-card-list">
              <li>Private consultations for high-net-worth individuals & collectors.</li>
              {/* <li>White-glove service including in-home styling recommendations.</li>
              <li>Exclusive membership access to first-look limited-edition designs.</li> */}
            </ul>
          </div>

          {/* Card 8 - Hospitality Solutions */}
          <div 
            className="services-section-5-card service-card-wrapper" 
            id="hospitality-solutions"
            data-service="hospitality-solutions"
          >
            <div className="services-section-5-card-image-wrapper">
              <img 
                src={serviceCard8Image} 
                alt="Hospitality Solutions" 
                className="services-section-5-card-image" 
              />
            </div>
            
            <h3 className="services-section-5-card-heading">
              Boutique Hotel & Luxury Hospitality Solutions
            </h3>
            
            <h4 className="services-section-5-card-subheading">
              Statement Pieces That Define Iconic Spaces.
            </h4>
            
            <ul className="services-section-5-card-list">
              <li>Custom-designed furniture & decor tailored for luxury hotels & residences.</li>
              {/* <li>Experience-driven design that enhances storytelling through interiors.</li>
              <li>Sustainable hospitality solutions for eco-conscious luxury spaces.</li> */}
            </ul>
          </div>

        </div>
      </section>

      {/* SECTION 6: Single Card - Art & Interior Styling */}
      <section className="services-section-6">
        <div 
          className="services-section-6-container service-card-wrapper" 
          id="art-interior-styling"
          data-service="art-interior-styling"
        >
            <div className="services-section-6-image-wrapper">
              <img 
                src={serviceCard9Image} 
                alt="Curated Art & Interior Styling" 
                className="services-section-6-image" 
              />
            </div>
            
            <div className="services-section-6-content">
              <h3 className="services-section-6-heading">
                Curated Art & Interior Styling
              </h3>
              
              <h4 className="services-section-6-subheading">
                Beyond Décor – Curating Experiences Through Design.
              </h4>
              
              <ul className="services-section-6-list">
                <li>Bespoke interior styling for collectors, estates, and boutique properties.</li>
                <li>Curation of handcrafted statement pieces that reflect personal style.</li>
                <li>Integration of modern & heritage elements into high-end interiors.</li>
              </ul>
            </div>
        </div>
      </section>

      {/* SECTION 7: CTA */}
      <section className='our-process-section-2'> 
        <h1 className='our-process-section-2-heading-text'>Let's Create Luxury Together</h1>
        <p className='our-process-section-2-para-text'>Whether you're envisioning an exclusive statement piece or an entire curated interior, Kara brings your design dreams to life—through craft, collaboration, and conscious luxury.</p>
        <Link to="/contact">
          <button className='our-process-section-2-contact-button'>Let's Create Luxury Together</button>
        </Link>
      </section>

      <Footer/>
    </>
  );
};

export default Services;